import React from 'react';
import { Container, Nav, NavDropdown, Navbar } from 'react-bootstrap';
import { Printer, FileExcel } from 'react-bootstrap-icons';

import 'jspdf-autotable';
import 'assets/css/table.css';

function NavMenu({ printListeArticle, exportCSVArticle }) {
    return (
        <Navbar expand="lg" bg="light" variant="light">
            <Container>
                <Nav className="me-auto">
                    <NavDropdown title="Exporter" id="basic-nav-dropdown">
                        <NavDropdown.Item href="#/admin/ventes" onClick={() => printListeArticle()}>
                            <Printer color="#0080ff" size={20} />
                            Liste des articles livrés/retournés (pdf)
                        </NavDropdown.Item>
                        <NavDropdown.Item href="#/admin/ventes" onClick={() => exportCSVArticle()}>
                            <FileExcel color="green" size={20} />
                            Liste des articles livrés/retournés (Excel)
                        </NavDropdown.Item>
                    </NavDropdown>
                </Nav>
            </Container>
        </Navbar>
    );
}
export default NavMenu;
